module.exports = __webpack_public_path__ + "static/media/about-eg-2.305c9b94.jpg";